// Shared primitives for the Security Centre.
import React from 'react';

export const API = process.env.REACT_APP_BACKEND_URL;
export const card = 'rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm';
export const input = 'w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#2E333B]/20';
export const btn = 'inline-flex items-center gap-1.5 rounded-xl bg-[#2E333B] px-3.5 py-2 text-sm font-semibold text-white hover:bg-[#1f232a] disabled:opacity-50 transition-colors';
export const btnGhost = 'inline-flex items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3.5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50 transition-colors';

export const fmt = (v) => (v ? new Date(v).toLocaleString('en-AU', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');
export const bytes = (n) => (n ? `${(n / 1024 / 1024).toFixed(1)} MB` : '—');

export const SEV = {
  critical: 'bg-rose-50 text-rose-700 border-rose-200',
  high: 'bg-rose-50 text-rose-700 border-rose-200',
  warning: 'bg-amber-50 text-amber-800 border-amber-200',
  medium: 'bg-amber-50 text-amber-800 border-amber-200',
  low: 'bg-slate-100 text-slate-600 border-slate-200',
  info: 'bg-sky-50 text-sky-700 border-sky-200',
};

export const Pill = ({ tone = 'info', children, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ${SEV[tone] || SEV.info}`}>{children}</span>
);

export const Stat = ({ label, value, sub, tone, testId }) => (
  <div className={card} data-testid={testId}>
    <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`mt-1 text-3xl font-black tabular-nums ${tone || 'text-[#2E333B]'}`}>{value}</div>
    {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
  </div>
);

export const Section = ({ title, action, children, testId }) => (
  <div className={card} data-testid={testId}>
    <div className="mb-4 flex items-center justify-between gap-3">
      <h2 className="font-bold text-[#2E333B]">{title}</h2>
      {action}
    </div>
    {children}
  </div>
);
